import {useToast} from 'vue-toastification'
import {Modal} from 'bootstrap'
import useApi from "@/composables/useApi";

export default function usePerformanceItem() {
    const toast = useToast()
    const {fetchResource, createResource, updateResource, deleteResource} = useApi()

    const baseStructure = {
        title: '', value: ''
    }

    const props = {
        subProcessId: {
            type: Number,
            required: true
        },
        type: {
            type: String,
            required: true
        },

        issu_id: {
        type: Number,
        required: true
    }
    }

    const data = () => ({
        items: [],
        modalId: generateUniqueNumber(),
        apiUrl: '/v2/performance-management/effects-measurement/performance-items',
        newItem: structuredClone(baseStructure),
        editedItem: null,
        editIndex: null,
        tableHeaders: ['عنوان', 'مقدار (واحد)'],
        tableFields: ['title', 'value'],
    })

    const generateUniqueNumber = () => new Date().getUTCMilliseconds() + Math.random()

    const methods = {
        validateItem(item) {
            if (!item.title || !item.value) {
                toast.error('همه فیلدها را کامل وارد کنید!')
                return false
            }
            return true
        },

        async fetchData() {
            const query = new URLSearchParams({type: this.type, sub_process_id: this.subProcessId,issue_id:this.issu_id}).toString()
            const response = await fetchResource(`${this.apiUrl}?${query}`)
            this.items = response.data
        },

        async addItem() {
            if (!this.validateItem(this.newItem)) return

            this.newItem['sub_process_id'] = this.subProcessId
            this.newItem['type'] = this.type
            this.newItem['issue_id'] = this.issu_id

            const response = await createResource(this.apiUrl, this.newItem)

            this.items.unshift(response.data)
            Object.assign(this.newItem, baseStructure)
        },

        async removeItem(index) {
            const deletedItem = this.items.find((_, i) => i === index);
            await deleteResource(`${this.apiUrl}/${deletedItem.id}`)
            this.items = this.items.filter((_, i) => i !== index)
        },

        async startEditing(item, index) {
            this.editedItem = structuredClone(item)
            this.editIndex = index
        },

        async editItem() {
            if (!this.validateItem(this.editedItem) || this.editIndex === null) throw new Error();

            const response = await updateResource(`${this.apiUrl}/${this.editedItem.id}`, this.editedItem)

            this.items.splice(this.editIndex, 1, response.data)
            this.editIndex = null
            this.editedItem = null
        },

        async openEditModal(item, index) {
            await this.startEditing(item, index)
            this.getModal().show()
        },

        async handleUpdate() {
            try {
                await this.editItem()
                this.getModal().hide()
            } catch (error) {
                console.log(error.message)
            }
        },

        getModal () {
            return Modal.getOrCreateInstance(document.getElementById(this.modalId))
        },
    }

    return {
        data, methods, props
    }
}
